import { UtcDate } from '@/helpers/date';

const failed = {
  valid: false,
  required: true,
};

export default {
  computesRequired: true,
  // TODO - fix parseRules(helper) to not add not required params to validation rules.
  // this is param is not required by the rule itself, but it used in parseRules(helper)
  params: ['dateOfInsuranceStart'],
  validate (value, { dateOfInsuranceStart }) {
    if ([undefined, null, ''].includes(value)) return failed;

    const valueDate = new UtcDate(value);

    if (!valueDate.isValid()) return failed;

    return {
      valid: true,
      required: true,
    };
  },
  message (fieldName, { _value_: value }) {
    const defaultMsg = 'Please enter the date.';
    if ([undefined, null, ''].includes(value)) return defaultMsg;
    const valueDate = new UtcDate(value);

    if (!valueDate.isValid()) return 'Invalid format for date of birth.';

    return defaultMsg;
  },
};
